import React from 'react';


function Loader() {
    return (
        <div className='container-fluid fondo'>
            <div className='row carousel-caption' id="carousel3">
                <div className="position-absolute top-50 start-50 translate-middle mt-3 mb-3 pt-3 pb-3">
                    <span className="loader">
                        <img className="img-fluid" src={require('../Images/logo-slowfood-icon.png')} id='slowFoodLogo' alt='logo Slow Food' />
                    </span>
                </div>
            </div>
        </div>
    )
}

export default Loader;